import { useRoutes } from "react-router-dom";
import { staticRoutes } from "./staticRoutes";
import NotFound from "../pages/NotFound";

const StaticRoutes = () => {
  const allRoutes = [
    ...staticRoutes,
    // 404 is already in staticRoutes, but ensure it's at the end
    { path: "*", element: <NotFound /> },
  ];

  return useRoutes(allRoutes);
};

export default StaticRoutes;
